// extracted by mini-css-extract-plugin
module.exports = {"radio":"RadioButton_radio__TRTdh","inputGroup":"RadioButton_inputGroup__svKu4","labelRadio":"RadioButton_labelRadio__MG_bn"};